module.exports = __webpack_public_path__ + "img/404.b89aa517.png";